import { render } from "./BaseCourseCard.vue?vue&type=template&id=5cf108fd&scoped=true&ts=true"
import script from "./BaseCourseCard.vue?vue&type=script&lang=ts"
export * from "./BaseCourseCard.vue?vue&type=script&lang=ts"

import "./BaseCourseCard.vue?vue&type=style&index=0&id=5cf108fd&lang=postcss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf108fd"]])

export default __exports__